import { render, staticRenderFns } from "./PepQuestionDisplay.vue?vue&type=template&id=be3eb200&scoped=true"
import script from "./PepQuestionDisplay.vue?vue&type=script&lang=js"
export * from "./PepQuestionDisplay.vue?vue&type=script&lang=js"
import style0 from "./PepQuestionDisplay.vue?vue&type=style&index=0&id=be3eb200&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be3eb200",
  null
  
)

export default component.exports